import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadpartytokenComponent } from '../uploadpartytoken/uploadpartytoken.component';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { ip } from 'src/app/constant/constant';
import { DataService } from 'src/app/services/data.service';
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  ValidatorFn,
  AbstractControl,
} from '@angular/forms';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    selector: 'app-invitation-modal',
    templateUrl: './invitation-modal.component.html',
    styleUrls: ['./invitation-modal.component.scss'],
    standalone: false
})
export class InvitationModalComponent implements OnInit {
  @Input() game_id: number;
  @Input() map_id: string;
  @Input() game_details: any;
  partyToken: string = '';
  loading: boolean = false;
  invitationForm: FormGroup;
  user_id: number;

  imageurl = ip;
  gamesystemlistdata: any;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private currentUserService: CurrentUserService,
    private dataService: DataService,
    private toasterService: ToastService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.currentUserService.currentUser.subscribe((data) => {
      if (data) {
        this.user_id = parseInt(data.id);
        this.cdr.detectChanges();
      }
    });
    this.invitationForm = this.formBuilder.group({
      gameSystem: [
        { value: this.game_details?.game_system, disabled: true },
        [Validators.required],
      ],
      emailRows: this.formBuilder.array(
        Array.from({ length: 8 }, () => this.createEmailRow()),
      ),
    });

    this.urlToBase64(this.imageurl + this.game_details.partytoken).then(
      (res) => {
        this.partyToken = res;
      },
    );
    this.productlist();
  }

  // Custom email validator
  strictEmailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) return null;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const valid = emailRegex.test(control.value);
      return valid ? null : { strictEmail: true };
    };
  }

  createEmailRow(): FormGroup {
    return this.formBuilder.group({
      email: [
        '',
        [Validators.required, Validators.email, this.strictEmailValidator()],
      ],
      level: [null, [Validators.min(0), Validators.required]],
      character_id: ['0'],
      game_id: [this.game_id],
      user_id: [this.user_id],
    });
  }

  productlist() {
    this.dataService.getproductlist('gamemaster').subscribe((data: any) => {
      if (data) {
        const gameMasterProducts = data.products.gamemaster;
        this.gamesystemlistdata = gameMasterProducts.filter(
          (item) => item.type === 'game_system',
        );
      }
    
          this.cdr.detectChanges();});
  }

  get emailRows(): FormArray {
    return this.invitationForm.get('emailRows') as FormArray;
  }

  urlToBase64(url: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result as string);};
        reader.onerror = function (error) {
          reject(error);
        };
        reader.readAsDataURL(xhr.response);};
      xhr.onerror = function (error) {
        reject(error);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }

  uploadPartyToken(data: any) {
    const modalRef = this.modalService.open(UploadpartytokenComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.masterUpdate = data.id;
    modalRef.result.then((res) => {
      if (res) {
        this.partyToken = res;
        this.cdr.detectChanges();
      }
    });
  }

  sendEmail() {
    const gameDetails = {
      user_id: this.user_id,
      game_system: this.invitationForm.get('gameSystem').value,
    };

    // Prepare email invitations payload (unchanged logic)
    const emailRowsArray = this.emailRows.controls;
    const validRows = emailRowsArray.filter(
      (control) => control.get('email').value.trim() !== '',
    );

    const emailPayload = validRows.map((control) => control.value);
    if (emailPayload.length === 0) {
      this.toasterService.showSuccess(
        'Please enter at least one email address.',
        'danger',
      );
      return;
    }

    const invalidRows = validRows.filter((control) => control.invalid);
    if (invalidRows.length > 0) {
      if (invalidRows.length > 0) {
        invalidRows.map((row) => {
          row.get('level').markAsTouched();
        });
        this.invitationForm.updateValueAndValidity();
      }
      return;
    }

    const emails = emailPayload.map((row) => row.email);
    const hasDuplicates = emails.some(
      (email, index) => emails.indexOf(email) !== index,
    );
    if (hasDuplicates) {
      this.toasterService.showSuccess('Duplicate emails detected.', 'danger');
      return;
    }
    let payload;

    // Combine game details and email invitations into a single payload
    payload = {
      gameDetails,
      invitations: emailPayload,
    };

    if (emailPayload.length === 0) {
      payload = {
        gameDetails,
        invitations: [],
      };
    }

    this.loading = true;

    this.dataService
      .sendemail(payload, parseInt(this.game_details.id))
      .subscribe(
        (res: any) => {
          this.loading = false;

          if (res?.invitations?.length) {
            // Iterate through all messages and display them
            res.invitations.forEach((invitation: any) => {
              this.toasterService.showSuccess(invitation.message, 'success');
            });
          } else if (res?.data?.length) {
            res.data.forEach((item: any) => {
              this.toasterService.showSuccess(item.message, 'success');
            });
          } else {
            this.toasterService.showSuccess('Invitation sent.', 'info');
          }

          this.closeModal(res);
        
          this.cdr.detectChanges();},
        (error) => {
          this.loading = false;
        
          this.cdr.detectChanges();},
      );
  }

  closeModal(data?: any) {
    this.activeModal.close(data);
  }
}
